<template>
  <div
    class="sj-panel-time"
    :style="{
      height: `${height}px`
    }"
  >
    <div class="sj-panel-time-item">
      <scrollBar
        :data="hourList"
        :height="height"
        :itemHeight="itemHeight"
        :dropdownShow="dropdownShow"
        v-model="selectedHour"
        @change="handleChange"
      ></scrollBar>
    </div>
    <div
      class="sj-panel-time-item"
      style="margin-left: 20px;"
      v-if="precision !== 'hour'"
    >
      <scrollBar
        :data="minuteList"
        :height="height"
        :itemHeight="itemHeight"
        :dropdownShow="dropdownShow"
        v-model="selectedMinute"
        @change="handleChange"
      ></scrollBar>
    </div>
    <div
      class="sj-panel-time-item"
      style="margin-left: 20px;"
      v-if="precision === 'second'"
    >
      <scrollBar
        :data="secondList"
        :height="height"
        :itemHeight="itemHeight"
        :dropdownShow="dropdownShow"
        v-model="selectedSecond"
        @change="handleChange"
      ></scrollBar>
    </div>
  </div>
</template>

<script>
import scrollBar from "../components/scrollBar";

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [0, 0, 0];
      }
    },
    height: {
      type: Number,
      default: 220
    },
    itemHeight: {
      type: Number,
      default: 30
    },
    precision: {
      type: String,
      default: "second",
      validator(v) {
        return ["second", "minute", "hour"].indexOf(v) !== -1;
      }
    },
    dropdownShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    scrollBar
  },
  data() {
    return {
      selectedHour: 0,
      hourList: Array.from({ length: 24 }).map((item, index) => ({
        label: `0${index}`.slice(-2),
        value: index
      })),
      selectedMinute: 0,
      minuteList: Array.from({ length: 60 }).map((item, index) => ({
        label: `0${index}`.slice(-2),
        value: index
      })),
      selectedSecond: 0,
      secondList: Array.from({ length: 60 }).map((item, index) => ({
        label: `0${index}`.slice(-2),
        value: index
      }))
    };
  },
  methods: {
    initSelected() {
      const { value } = this;
      if (
        Object.prototype.toString.call(value) === "[object Array]" &&
        value.length >= 3
      ) {
        this.selectedHour = value[0];
        this.selectedMinute = value[1];
        this.selectedSecond = value[2];
      }
    },
    handleChange() {
      const { selectedHour, selectedMinute, selectedSecond } = this;
      const newValue = [selectedHour, selectedMinute, selectedSecond];
      this.$emit("input", newValue);
      this.$emit("change", newValue);
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.initSelected();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sj-panel-time {
  display: flex;
  .sj-panel-time-item {
    flex-grow: 1;
    min-width: 0;
    height: 100%;
  }
}
</style>
